import { useEffect, useRef, useState } from "react";

// Poll an async fetcher on an interval. Returns { data, refetch, loading }.
export function usePoll(fetcher, ms = 4000, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const saved = useRef(fetcher);
  saved.current = fetcher;

  const run = async () => {
    try {
      const d = await saved.current();
      setData(d);
    } catch (e) {
      /* keep last */
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    run();
    if (!ms) return;
    const id = setInterval(run, ms);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, refetch: run, loading };
}
